import Result from '../Result/Result';
import ResultV22 from '../ResultV22/ResultV22';
import { useFeatureFlagVariantKey } from 'posthog-js/react';

// Shares the programs-v2-2-experiment flag with ProgramsV22ExperimentEntry so a visitor sees
// the v2.2 result page and the v2.2 programs page as one consistent variant.
export default function ResultV22ExperimentEntry() {
    const variant = useFeatureFlagVariantKey('programs-v2-2-experiment');

    if (variant === 'test') {
        return <ResultV22 />;
    }

    return <Result />;
}
